module.exports = __webpack_public_path__ + "img/IMG_9701_L_Wood.643ea1ca.jpg";